import moment from 'moment-timezone'

import { store } from 'redux/store'

let currentValue
const setTimeZone = () => {
  let prevValue = currentValue
  const locations = store.getState().profile.userData.locations
  currentValue = locations?.length && locations[0].timezone

  if (currentValue !== prevValue) {
    moment.tz.setDefault(currentValue)
  }
}

store.subscribe(setTimeZone)

export default moment
